<app-report-runner
  reportType="program-summary"
  title="Program Summary Report"
  description="Program-level totals for individuals served, outreach, services, mediations, outcomes, and geography."
/>
